/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dataExportsCreateRoute } from "../funcs/dataExportsCreateRoute.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DataExportRoute } from "../models/components/dataexportroute.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateDataExportRouteRequest,
  CreateDataExportRouteSecurity,
} from "../models/operations/createdataexportroute.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateDataExportRouteMutationVariables = {
  request: CreateDataExportRouteRequest;
  security?: CreateDataExportRouteSecurity | undefined;
  options?: RequestOptions;
};

export type CreateDataExportRouteMutationData = DataExportRoute;

export type CreateDataExportRouteMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createRoute dataExports
 *
 * @remarks
 * Create the selected data source's export route configuration.
 */
export function useCreateDataExportRouteMutation(
  options?: MutationHookOptions<
    CreateDataExportRouteMutationData,
    CreateDataExportRouteMutationError,
    CreateDataExportRouteMutationVariables
  >,
): UseMutationResult<
  CreateDataExportRouteMutationData,
  CreateDataExportRouteMutationError,
  CreateDataExportRouteMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateDataExportRouteMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateDataExportRoute(): MutationKey {
  return ["@gram/client", "dataExports", "createRoute"];
}

export function buildCreateDataExportRouteMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateDataExportRouteMutationVariables,
  ) => Promise<CreateDataExportRouteMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateDataExportRoute(),
    mutationFn: function createDataExportRouteMutationFn({
      request,
      security,
      options,
    }): Promise<CreateDataExportRouteMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(dataExportsCreateRoute(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
